import React from "react";
import {
  AddIcon,
  CloudIcon,
  DownloadIcon,
  FilterIcon,
} from "../../assets/icons/index.js";
import jsonToXlsx from "../../helpers/formTools/transformations/jsonToXlsx";
import DataDropdown from "../DataDropdown";

export const subHeaderRightNavOptions = (
  userCanWrite,
  data,
  navigate,
  handleFilter
) => ({
  icons: [
    false && {
      icon: <CloudIcon fillColor="var(--archeo-color)" />,
      onClick: () => console.log("Upload"),
      label: "Upload",
    },
    userCanWrite && {
      icon: <AddIcon fillColor="var(--archeo-color)" />,
      label: "Aggiungi",
      onClick: () => navigate("/pubblicazioni/add"),
    },
    {
      icon: <FilterIcon fillColor="var(--archeo-color)" />,
      onClick: () => {
        handleFilter();
      },
      label: "Filtro",
    },
    {
      icon: <DownloadIcon fillColor="var(--archeo-color)" />,
      label: "Download",
      onClick: () => {
        const jsonArr = data.map(({ actions, ...rest }) => rest);
        jsonToXlsx(jsonArr, "pubblicazioni.xlsx");
      },
    },
  ],
  components: [<DataDropdown defaultSelected="PUBBLICAZIONI" />],
});
